import React from 'react';
import { LogoResultContainer } from '../../components/redesignComponents/ResultPageComponents/v2/SelectedQuoteCard.styles';
import { BACKEND_BASE_URL } from '../../../config';

function LogoComponentResult({ quote }) {
  return (
    <LogoResultContainer>
      {quote.company && (
        <img
          src={BACKEND_BASE_URL + quote.company.logo}
          alt={`${quote.company.name} Logo`}
        />
      )}
      {quote.preventivas_company && (
        <img
          src={`${BACKEND_BASE_URL}/preventivass/companies/${quote.preventivas_company.logo_filename}`}
          alt={`${quote.preventivas_company.company_name} Logo`}
        />
      )}
    </LogoResultContainer>
  );
}

export default LogoComponentResult;
